import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent implements OnInit {
  lang: any;
  termsAgreed: any;
  userRole: any;
  userType: any;

  constructor(private auth: AuthService, private user: UserService, private router: Router, private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'jp']);
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this.lang = localStorage.getItem('site_lang') ?? 'en';
      this.translate.use(this.lang);
    }

    this.userRole = this.auth.getRole();
    this.userType = this.auth.getType();
    this.termsAgreed = this.auth.getNotice();
  }

  giveConsent(isChecked: boolean) {
    if (!isChecked) {
      //alert('Please accept the privacy policy to proceed.');
      alert(this.translate.instant('Accept_Privacy_Policy'));
      return;
    }

    const consentObj = { termId: 1, termValue: true };
    this.user.giveConsent(consentObj)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            if (this.userRole == 'Client') {
              this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
            } else if (this.userRole == 'Staff') {
              this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
            } else if (this.userRole == 'Admin' || this.userRole == 'Rep') {
              if (this.userType == 'C') {
                if (this.userRole == 'Admin') {
                  this.router.navigate(['admin-home']);
                } else {
                  this.router.navigate(['representative-home']);
                }
              } else if (this.userType == 'B' || this.userType == 'D') {
                this.router.navigate(['client-associatelist']);
              } else if (this.userType == 'A') {
                this.router.navigate(['asc-report']);
              }
            } else if (this.userRole == 'Manager') {
              this.router.navigate(['manager-home']);
            }
          }
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.auth.logout();
          }
        }
      });
  }

  cancelConsent() {
    this.auth.logout();
  }
}
